import * as CL from '@design-system/component-library';
import {
  costCenterAndReferenceMsg,
  costCenterToolTipMsg,
  referenceMsg,
  referenceToolTipMsg,
  t,
} from '../../../../../../common/i18n';
import { CostCenter } from '../../../../../../common/react-hook-form/fields/CostCenter';
import { Reference } from '../../../../../../common/react-hook-form/fields/Reference';
import { GridColumn } from '../../../../../BillingAccountDetails/components/GridColumn';

interface CustomCostCenterAndEmployeeNumberProps {
  isCostCenterRequired?: boolean;
  showCostCenter?: boolean;
  showReference?: boolean;
}

export const CustomCostCenterAndEmployeeNumber = ({
  isCostCenterRequired = false,
  showCostCenter = true,
  showReference = true,
}: CustomCostCenterAndEmployeeNumberProps) => (
  <div className="of-place-order-contact-or-purpose__cost-center-employee-number">
    {(showCostCenter || showReference) && <h4>{t.JBEM(costCenterAndReferenceMsg)}</h4>}
    <CL.Grid>
      <CL.GridRow className="of-purpose-of-use__grid_row">
        {showCostCenter && (
          <GridColumn className="of-purpose-of-use__grid_col">
            <CostCenter name="costCenter" tooltip={`${t.UE8R(costCenterToolTipMsg)}`} required={isCostCenterRequired} />
          </GridColumn>
        )}

        {showReference && (
          <GridColumn className="of-purpose-of-use__grid_col">
            <Reference label={t.LVRN(referenceMsg)} name="employeeNumber" tooltip={t.HBBD(referenceToolTipMsg)} />
          </GridColumn>
        )}
      </CL.GridRow>
    </CL.Grid>
  </div>
);
